// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__4hQNi","wrapper_closeButton":"styles_wrapper_closeButton__Gsu9h"};